import gql from 'graphql-tag';
import createQuery from './createQuery';

export default createQuery(gql`
  mutation deleteKey($domain: String!, $key: String!) {
    deleteKey(domain: $domain, key: $key)
  }
`);
